import { render } from "./symbolTag.vue?vue&type=template&id=6d84ec4d&scoped=true"
import script from "./symbolTag.vue?vue&type=script&lang=js"
export * from "./symbolTag.vue?vue&type=script&lang=js"

import "./symbolTag.vue?vue&type=style&index=0&id=6d84ec4d&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d84ec4d"]])

export default __exports__